function generateYearLabels() {
  const yearShort = new Date().getFullYear().toString().slice(-2);
  return [...Array(12)].map((_, i) =>
    `${String(i + 1).padStart(2, '0')}/${yearShort}`
  );
}

export default {
  chartOptions: {
    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: '50px'
      }
    },
    chart: {
      height: 350,
      type: 'line',
      toolbar: {
        show: false
      }
    },
    colors: ['#62f436', '#31500e'],
    stroke: {
      width: [0, 4],
      curve: 'smooth'
    },
    markers: {
      size: 5
    },
    dataLabels: {
      enabled: false,
      enabledOnSeries: [1],
    },
    labels: generateYearLabels(),
    yaxis: {
      labels: {
        style: {
          fontSize: '20px'
        }
      }
    },
    xaxis: {
      labels: {
        style: {
          fontSize: '20px'
        }
      }
    }
  }
}
